
import { defineComponent, reactive, onMounted, ref } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'
import { ResponseJunshisanSetting } from '@/repositories/fuzoku-meisai/junsoku/data'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import { junsokuRepositories } from '@/repositories/fuzoku-meisai/junsoku/junsokuRepositories'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { callApiWrapper } from '@/views/callApiWrapper'
import JunsokuSettingTitle from '@/views/fuzoku-meisai/junsoku/JunsokuSettingTitle.vue'

const repository = junsokuRepositories.junshisan

interface State {
  setting: ResponseJunshisanSetting;
}

export default defineComponent({
  components: {
    JunsokuSettingTitle,
    ResponseResultAlert,
    LoadingButton,
    ContentLayout,
    SettingPanel
  },

  setup () {
    const loading = ref(false)
    const isSucceedResponse = ref(false)
    const requestError = ref<string | null>(null)
    const state = reactive<State>({
      setting: {
        zandaka: {
          sources: [],
          targets: []
        },
        junsoneki: {
          sources: [],
          targets: []
        }
      }
    })

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        state.setting = await repository.list()
      })
      loading.value = false
    })

    const onUpdatedSetting = (panelName: string, settingItem: ResponseSettingItem) => {
      switch (panelName) {
        case 'zandaka':
          state.setting.zandaka = settingItem
          break
        case 'junsoneki':
          break
        default:
          console.error(`unknown panel name. name: ${panelName}`)
          break
      }
    }

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()
      await callApiWrapper(requestError, async () => {
        await repository.save(state.setting)
        state.setting = await repository.list()
        isSucceedResponse.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedResponse.value = false
      requestError.value = null
    }

    return {
      state,
      isSucceedResponse,
      requestError,
      loading,
      onUpdatedSetting,
      onClickRegister,
      onDismissAlert
    }
  }
})
